<div class="d-flex w-100 flex-column align-items-center p-3 p-lg-4">
    <!-- Special handling for NO_PRINTER_FOUND_WITH_THIS_CODE -->
    <ng-container *ngIf="isNoPrinterFoundError(); else defaultError">
        <h1 mat-dialog-title class="text-center py-1 py-lg-3 fw-bold zx-text-22 text-green" [class.zx-rtl]="isRTL"
            [class.zx-text-white]="isDarkMode">
            {{ "error-title-" + data.message | translate }}
        </h1>
        <div mat-dialog-content
            class="w-100 p-0 d-flex flex-column align-items-center justify-content-center gap-2 gap-lg-3">
            <img class="zx-big-icon-size zx-huge-icon-size-lg" src="assets/images/negative-icon.svg">
            
            <!-- First step content -->
            <ng-container *ngIf="!showSecondStep">
                <p class="text-center text-green fw-bold" [class.zx-rtl]="isRTL" [class.zx-text-white]="isDarkMode">
                    {{ "error-content-NO_PRINTER_FOUND_WITH_THIS_CODE_SPECIAL" | translate }} {{ getTranslatedBranchName() }}?
                </p>
                <button mat-raised-button (click)="openWhatsApp()" class="rounded-pill zx-text-tiny zx-text-sm-small">
                    <div class="w-100 h-100 d-flex align-items-center gap-2">
                        <div class="whatsup-logo-container-small">
                            <img src="assets/images/whatsup-logo.svg" alt="WhatsUp Logo" class="whatsup-logo-small">
                        </div>
                        <span class="zx-text-tiny-tiny">
                            {{'my-orders.contact-us-for-help' | translate}}
                        </span>
                    </div>
                </button>
            </ng-container>

            <!-- Second step content -->
            <ng-container *ngIf="showSecondStep">
                <p class="text-center text-green fw-bold" [class.zx-rtl]="isRTL" [class.zx-text-white]="isDarkMode">
                    {{ "error-content-choose-printer-or-branch-question" | translate }}
                </p>
            </ng-container>
        </div>

        <!-- First step buttons -->
        <ng-container *ngIf="!showSecondStep">
            <div mat-dialog-actions class="w-100 row d-flex justify-content-center gap-2">
                <div tabindex="0" cdkFocusInitial></div>
                <button mat-raised-button (click)="onSwitchBranch()" class="col col-lg-5 rounded-pill text-white" style="background-color: var(--zx-green);">
                    {{ "error-content-switch-branch-btn" | translate }}
                </button>
                <button mat-raised-button (click)="onReenterCode()" class="col col-lg-5 rounded-pill">
                    {{ "error-content-reenter-code-btn" | translate }}
                </button>
            </div>
        </ng-container>

        <!-- Second step buttons -->
        <ng-container *ngIf="showSecondStep">
            <div mat-dialog-actions class="w-100 row d-flex justify-content-center gap-2">
                <div tabindex="0" cdkFocusInitial></div>
                <button mat-raised-button (click)="onChooseDifferentPrinterInBranch()" class="col col-lg-5 rounded-pill text-white" style="background-color: var(--zx-green);">
                    {{ "error-content-different-printer-in-branch-btn" | translate }} {{ getTranslatedBranchName() }}
                </button>
                <button mat-raised-button (click)="onChooseDifferentBranch()" class="col col-lg-5 rounded-pill">
                    {{ "error-content-different-branch-btn" | translate }}
                </button>
            </div>
        </ng-container>
    </ng-container>

    <!-- Default error display for all other errors -->
    <ng-template #defaultError>
        <h1 mat-dialog-title class="text-center py-1 py-lg-3 fw-bold zx-text-22 text-red" [class.zx-rtl]="isRTL"
            [class.zx-text-white]="isDarkMode">
            {{ "error-title-" + data.message | translate }}
        </h1>
        <div mat-dialog-content
            class="w-100 p-0 d-flex flex-column align-items-center justify-content-center gap-2 gap-lg-3"
            [class.error-dialog-content--with-details]="hasErrorDetails()">
            <img class="zx-big-icon-size zx-huge-icon-size-lg" src="assets/images/negative-icon.svg">
            <p class="text-center text-red fw-bold error-message-text" [class.zx-rtl]="isRTL" [class.zx-text-white]="isDarkMode">
                {{ "error-content-" + data.message | translate }}
            </p>
            <p *ngIf="hasErrorDetails()"
                class="text-center text-red error-message-text zx-text-small" [class.zx-rtl]="isRTL" [class.zx-text-white]="isDarkMode">
                <span>{{ "error-details-heading" | translate }}</span> {{ data.details }}
            </p>
            <!-- Copy Error Details Button -->
            <button (click)="copyErrorDetails()" 
                class="d-flex align-items-center gap-2 c-pointer border-0 bg-transparent p-0"
                [class.zx-ltr]="!isRTL"
                tabindex="-1">
                <mat-icon class="text-green zx-text-small m-0 copy-error-icon">content_copy</mat-icon>
                <span class="text-green zx-text-small m-0" [class.zx-text-white]="isDarkMode">
                    {{ "file-issues.copy-error-details" | translate }}
                </span>
            </button>
        </div>

        <!-- Buttons -->
        <div class="d-flex flex-column flex-lg-row flex-grow-lg-1 justify-content-center align-items-end w-100 gap-3">
            <div tabindex="0" cdkFocusInitial></div>
            <button color="primary" mat-raised-button (click)="openWhatsApp()"
                class="text-white rounded-pill zx-btn-single col-12 col-lg-6 fw-bold order-1 order-lg-1">
                {{'my-orders.contact-us-for-help' | translate}}
            </button>
            <button (click)="closeErrorDialog()" color="primary" mat-button
                class="rounded-pill zx-btn-single col-12 col-lg-6 fw-bold order-2 order-lg-2">
                {{ "error-content-ok-btn" | translate }}
            </button>
        </div>
    </ng-template>
</div>